import React, { FC, useState } from 'react';
import { Box } from '@mui/material';

import { Typography } from '../Typography/Typography';
import Accordion from '../Accordion/Accordion';

import { accordionStyle } from './styles';

interface EquipmentSectionProps {
  equipment?: string[];
}

export const EquipmentSection: FC<EquipmentSectionProps> = ({
  equipment = [],
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (equipment.length === 0) {
    return null;
  }

  return (
    <Accordion
      title="Equipment needed"
      expanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
      accordionStyle={accordionStyle}
      i18nKeyTitle="meals:dishDetails.equipment"
    >
      <Box
        display="flex"
        alignItems="flex-start"
        alignContent="flex-start"
        gap="8px 16px"
        alignSelf="stretch"
        flexWrap="wrap"
      >
        {equipment.map((item, index) => (
          <Box key={index} display="flex" alignItems="center" gap={1}>
            <Box
              width={4}
              height={4}
              borderRadius="50%"
              bgcolor="text.secondary"
              flexShrink={0}
            />
            <Typography variant="body1" color="text.secondary">
              {item}
            </Typography>
          </Box>
        ))}
      </Box>
    </Accordion>
  );
};

export default EquipmentSection;
